/**
 * Helper to get display name for test type
 */
export function getTestTypeDisplayName(testType) {
    switch (testType) {
        case 'three_point_calibration':
            return '3-Point Calibration';
        case 'one_point_calibration':
            return '1-Point Calibration';
        default:
            return testType;
    }
}
/**
 * Type guard for 3-point calibration
 */
export function isThreePointCalibration(test) {
    return test.test_type === 'three_point_calibration';
}
/**
 * Type guard for 1-point calibration
 */
export function isOnePointCalibration(test) {
    return test.test_type === 'one_point_calibration';
}
